import { type PayoutMethodResource } from '@/features/payouts/api/resources/payout-method'
import { type PayoutMethodProps } from './PayoutMethod'

/**
 * Maps a pro's payout method.
 */
export function mapPayoutMethodResourceToProps(
  resource: PayoutMethodResource,
): PayoutMethodProps {
  return {
    id: resource.id,
    type: resource.type,
    stripeAccountId: resource.stripe_account_id,
    userId: resource.user_id,
  }
}
